import { useEffect } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
} from '@material-ui/core';
import { PricingPlan } from '../components/pricing';
import gtm from '../lib/gtm';

const Pricing = () => {
  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.paper',
          minHeight: '100%',
          pb: 6
        }}
      >
        <Box
          sx={{
            backgroundColor: 'background.default',
            py: 6
          }}
        >
          <Container maxWidth="lg">
            <Grid
              container
              alignItems="center"
              spacing={2}
              flexWrap="nowrap"
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <Typography
                  color="textPrimary"
                  variant="h3"
                  align="center"
                >
                  Unsere eyerena Pakete 2025 - bald verfügbar
                  {' '}
                  <br />
                  {' '}
                  Mehr Funktionen - Gleicher Preis
                </Typography>
                <Typography
                  color="textSecondary"
                  sx={{ my: 2 }}
                  variant="body1"
                  align="center"
                >
                  Du kannst eyerena Paketen wählen. Vergleiche die Pakete in Ruhe.
                  <br />
                  Bei Fragen steht Dir das eyerena Team gerne zur Verfügung.
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Container
          maxWidth="lg"
          sx={{ py: 6 }}
        >
          <Grid
            container
            spacing={6}
          >
            <Grid
              item
              md={4}
              xs={12}
            >
              <PricingPlan
                currency="€"
                description="Lerne die eyerena Plattform kennen und verwalte Deine eigenen Übungen. Entdecke die ersten ViCo Materialien und Tests und nutze das ständig wachsende Wiki."
                features={[
                  'Zugriff auf 10 vordefinierte Übungen',
                  'Eigene Übungen anlegen und verwalten',
                  'Zugriff auf 2 ViCo Materialien: Enigma und Find Numbers',
                  'Zugriff auf einfache ViCo Tests wie Reaction Arrows oder Speedreading Level 1',
                  'Zugriff auf ein ständig wachsendes ViCo Wiki',
                  'Dokumentationen zur Visualhygiene und Leitfaden zum Thema ViCo',
                  'Kundenservice per E-Mail'
                ]}
                name="Free"
                price="0"
                sx={{
                  height: '100%',
                  maxWidth: 460,
                  mx: 'auto'
                }}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <PricingPlan
                currency="€"
                description="Erhalte Zugriff auf alle Übungen und Tests. Erstelle und verwalte eigene Übungen sowie Schüler:innen und dokumentiere Assessments – alles zentral abgelegt und jederzeit abrufbar."
                features={[
                  'Alle Funktionen der Free Version',
                  'Zugriff auf alle vordefinierten Übungen',
                  'Möglichkeit, Deine Übungen mit der Community zu teilen',
                  'Zugriff auf das vollständige ViCo Material aus den Bereichen Zahlen, Buchstaben & Worte und bilaterale Ingetration',
                  'PDF Trainingspläne mit bis zu 6 Übungen',
                  'Ausdruck der Trainingspläne zur Weitergabe an Deine Schüler:innen',
                  'Anlage und Verwaltung Deiner Schüler:innen',
                  'Anlage und Verwaltung von Assessments',
                  'Ausdruck der Assessments mit allen relevanten Informationen',
                  'Exklusiver Kundenservice per E-Mail und Telefon'
                ]}
                name="Trainer"
                popular
                price="19.99"
                sx={{
                  height: '100%',
                  maxWidth: 460,
                  mx: 'auto'
                }}
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <PricingPlan
                description="Passe Deinen Trainingsplan für Deine Schüler:innen nach Deinen Vorstellungen an. Füge Dein eigenes Logo, eine personalisierte Fußzeile sowie eigene Begriffe und Texte hinzu."
                features={[
                  'Druck von Trainingsplänen mit individuellem Logo',
                  'Trainingspläne mit personalisierter Fußzeile',
                  'Ausdruck in Schwarzweiß oder Farbe',
                  'Anpassung von speziellen Begriffen und Texten im Trainingsplan',
                  'Gemeinsames Zoom-Meeting zur Abstimmung der Personalisierung (ca. 30 Minuten)',
                ]}
                name="Personalisieren"
                popular
                price="ab 79€ einmalig"
                interval=""
                sx={{
                  height: '100%',
                  maxWidth: 460,
                  mx: 'auto'
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <Typography
          align="center"
          color="textSecondary"
          component="p"
          variant="caption"
        >
          Alle Preise verstehen sich inkl. Mehrwertsteuer.
        </Typography>
      </Box>
    </>
  );
};

export default Pricing;
